import { CssBaseline, ThemeProvider } from '@mui/material';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { Provider } from 'react-redux';
import { Route, Routes, useLocation } from 'react-router-dom';
import {
  APP_LINK,
  APP_LINKS,
  APP_LINKS2,
} from '../common/menu/menuItems/menuList';
import SideBar from '../common/menu/screen/sideBar';
import TopBar from '../common/Top/topBar';
import '../css/style.css';
import { store } from '../redux/Store/store';
import { createCustomTheme } from '../Theme';
import AdmissionDetails from '../ui/admissions/AddAdmissions.jsx';
import AdmissionAdd from '../ui/admissions/AdmissionAdd.jsx';
import ListAdmissionDetails from '../ui/admissions/AdmissionsList';
import EditAdmissionDetails from '../ui/admissions/EditAdmissions';
import ListAdmissions from '../ui/admissions/Listadmissions';
import ViewAdmissionDetails from '../ui/admissions/viewAdmissions';
import ChangePassword from '../ui/auth_Screen/changePassword';
import ForgotPasswordPage from '../ui/auth_Screen/forgotPassword';
import Login from '../ui/auth_Screen/login';
import UserProfile from '../ui/auth_Screen/Myprofile';
import OtpPage from '../ui/auth_Screen/OtpPage';
import PasswordResetPage from '../ui/auth_Screen/PasswordPage';
import { default as SignUp } from '../ui/auth_Screen/signUp';
import Dashboard from '../ui/Dashboard';
import DoctorDashboard from '../ui/DoctorDashboard';
import AddDoctor from '../ui/doctors_screen/AddDoctor';
import EditDoctor from '../ui/doctors_screen/EditDoctor';
import ListDoctor from '../ui/doctors_screen/ListDoctors';
import ViewDoctor from '../ui/doctors_screen/ViewDoctors';
import HistoryList from '../ui/history/HistoryList';
import LogoutPage from '../ui/logout';
import AddPatient from '../ui/Patient_Screen/AddPatient';
import EditPatient from '../ui/Patient_Screen/EditPatient';
import PatientList from '../ui/Patient_Screen/ListPatient';
import DoctorPatientList from '../ui/Patient_Screen/ListPatientDoctor';
import StaffPatientList from '../ui/Patient_Screen/ListStaffPatient';
import ViewPatient from '../ui/Patient_Screen/viewPatient';
import AddOrganization from '../ui/organization/AddOrganization.jsx';
import EditOrganization from '../ui/organization/EditOrganization';
import ListOrganization from '../ui/organization/ListOrganization';
import ViewOrganization from '../ui/organization/ViewOrganization';
import DoctorProfile from '../ui/profile/DoctorProfile';
import StaffProfile from '../ui/profile/StaffProfile';
import DailyLog from '../ui/Report/dailyLog';
import RolePermissionTable from '../ui/Role/rolePermissionList';
import AddRole from '../ui/roles/addRole';
import EditRole from '../ui/roles/editRole';
import RolesList from '../ui/roles/listRole';
import ViewRole from '../ui/roles/viewRole';
import AddSecurityGuard from '../ui/security_guard/AddsecurityGuard';
import EditSecurityGuard from '../ui/security_guard/EditsecurityGuard';
import SecurityGuardList from '../ui/security_guard/ListsecurityGuard';
import DoctorSGList from '../ui/security_guard/listSGDoctor';
import ViewSecurityGuard from '../ui/security_guard/ViewsecurityGuard';
import AddStaff from '../ui/staff/AddStaff';
import EditStaff from '../ui/staff/EditStaff';
import ListStaff from '../ui/staff/ListStaff';
import DoctorStaffList from '../ui/staff/ListStaffDoctor';
import StaffTransferHistoryList from '../ui/staff/StaffTransferHistory';
import OverAllHistoryList from '../ui/staff/TransferHistory';
import PatientTransferForm from '../ui/staff/TransferPatient';
import ViewStaff from '../ui/staff/ViewStaff';
import StaffDashboard from '../ui/StaffDashboard';
import SuperAdminDashboard from '../ui/SuperAdminDashboard.jsx';
import BlockList from '../ui/system_requirement/blocklist';
import DepartmentManagementForm from '../ui/system_requirement/departmentList';
import FloorList from '../ui/system_requirement/floorList';
import SpecializationManagementForm from '../ui/system_requirement/ListSpecialList';
import HospitalManagementForm from '../ui/system_requirement/wardList';
const RoutesComponent = () => {
  const location = useLocation();
  const themeSettings = createCustomTheme();
  const isAuthPage =
    location.pathname === APP_LINK.LOGIN ||
    location.pathname === APP_LINK.REGISTER ||
    location.pathname === APP_LINK.FORGOTPASSWORD ||
    location.pathname === APP_LINK.OTPREQUEST ||
    location.pathname === APP_LINK.PASSWORDRESET;
  return (
    <Provider store={store}>
      <ThemeProvider theme={themeSettings}>
        <CssBaseline />
        <div className="app">
          {!isAuthPage && <SideBar />}
          <main className="content">
            {!isAuthPage && <TopBar />}
            <div className="content">
              <Routes>
                {/*-- Auth components -- */}
                <Route path={APP_LINK.LOGIN} element={<Login />} />
                <Route path={APP_LINK.REGISTER} element={<SignUp />} />
                <Route
                  path={APP_LINK.FORGOTPASSWORD}
                  element={<ForgotPasswordPage />}
                />
                <Route
                  path={APP_LINKS2.DOCTORCHANGEPASSWORD}
                  element={<ChangePassword />}
                />
                <Route path={APP_LINK.OTPREQUEST} element={<OtpPage />} />
                <Route
                  path={APP_LINK.PASSWORDRESET}
                  element={<PasswordResetPage />}
                />
                <Route
                  path={APP_LINK.CHANGEPASSWORD}
                  element={<ChangePassword />}
                />
                <Route
                  path={APP_LINKS.STAFFCHANGEPASSWORD}
                  element={<ChangePassword />}
                />
                {/* <Route path={APP_LINK.MYPROFILE} element={<SignupPage />} /> */}

                <Route
                  path={APP_LINK.DEPARTMENTLIST}
                  element={<DepartmentManagementForm />}
                />
                {/*-- Organization components -- */}
                <Route path={APP_LINK.ADDORGANIZATION} element={<AddOrganization />} />
                <Route path={APP_LINK.EDITORGANIZATION} element={<EditOrganization />} />
                <Route path={APP_LINK.VIEWORGANIZATION} element={<ViewOrganization />} />
                <Route path={APP_LINK.LISTORGANIZATION} element={<ListOrganization />} />

                {/*-- Patients components -- */}
                <Route path={APP_LINK.ADDPATIENT} element={<AddPatient />} />
                <Route path={APP_LINK.EDITPATIENT} element={<EditPatient />} />
                <Route
                  path={APP_LINK.LISTALLPATIENT}
                  element={<PatientList />}
                />
                <Route path={APP_LINK.VIEWPATIENT} element={<ViewPatient />} />

                {/*-- Admissions components -- */}
                <Route
                  path={APP_LINK.ADMISSIONDETAILS}
                  element={<AdmissionDetails />}
                />
                <Route
                  path={APP_LINK.UPDATEADMISSIONDETAILS}
                  element={<EditAdmissionDetails />}
                />
                <Route
                  path={APP_LINK.VIEWADMISSIONSDETAILS}
                  element={<ViewAdmissionDetails />}
                />
                <Route
                  path={APP_LINK.LISTADMISSIONDETAILS}
                  element={<ListAdmissionDetails />}
                />
                <Route
                  path={APP_LINK.ADDADMISSIONDETAILS}
                  element={<AdmissionAdd />}
                />

                <Route
                  path={APP_LINK.LISTADMISSIONS}
                  element={<ListAdmissions />}
                />

                {/*-- Security Guard components -- */}
                <Route
                  path={APP_LINK.ADDSECURITYGUARD}
                  element={<AddSecurityGuard />}
                />
                <Route
                  path={APP_LINK.EDITSECURITYGUARD}
                  element={<EditSecurityGuard />}
                />
                <Route
                  path={APP_LINK.LISTECURITYGUARD}
                  element={<SecurityGuardList />}
                />
                <Route
                  path={APP_LINK.VIEWSECURITYGUARD}
                  element={<ViewSecurityGuard />}
                />

                {/*-- Dashboard components -- */}
                <Route path={APP_LINK.DASHBOARD} element={<Dashboard />} />
                <Route
                  path={APP_LINK.SUPERADMINDASHBOARD}
                  element={<SuperAdminDashboard />}
                />

                {/*-- Staff Dashboard components -- */}
                <Route
                  path={APP_LINK.STAFFDASHBOARD}
                  element={<StaffDashboard />}
                />

                {/*-- Doctor Dashboard components -- */}
                <Route
                  path={APP_LINKS2.DOCTORDASHBOARD}
                  element={<DoctorDashboard />}
                />

                {/*-- Profile components -- */}
                <Route path={APP_LINK.MYPROFILE} element={<UserProfile />} />

                {/*-- Staff components -- */}
                <Route path={APP_LINK.ADDSTAFF} element={<AddStaff />} />
                <Route path={APP_LINK.EDITSTAFF} element={<EditStaff />} />
                <Route path={APP_LINK.LISTALLSTAFF} element={<ListStaff />} />
                <Route path={APP_LINK.VIEWSTAFF} element={<ViewStaff />} />
                <Route path ={APP_LINK.DAILYREPORT} element={<DailyLog />} />

                <Route
                  path={APP_LINK.SPECIALIST}
                  element={<SpecializationManagementForm />}
                />

                {/*-- Doctor components -- */}
                <Route path={APP_LINK.ADDDOCTOR} element={<AddDoctor />} />
                <Route path={APP_LINK.EDITDOCTOR} element={<EditDoctor />} />
                <Route path={APP_LINK.LISTDOCTOR} element={<ListDoctor />} />
                <Route path={APP_LINK.VIEWDOCTOR} element={<ViewDoctor />} />

                {/*-- Profile components -- */}
                <Route
                  path={APP_LINK.DOCTORPROFILE}
                  element={<DoctorProfile />}
                />
                <Route
                  path={APP_LINK.STAFFPROFILE}
                  element={<StaffProfile />}
                />

                {/*-- Staff Patients components -- */}
                <Route
                  path={APP_LINKS.STAFFADDPATIENT}
                  element={<AddPatient />}
                />
                <Route
                  path={APP_LINKS.STAFFEDITPATIENT}
                  element={<EditPatient />}
                />
                <Route
                  path={APP_LINK.STAFFLISTALLPATIENT}
                  element={<StaffPatientList />}
                />
                <Route
                  path={APP_LINKS.STAFFVIEWPATIENT}
                  element={<ViewPatient />}
                />

                {/*--  Doctor List components -- */}
                <Route
                  path={APP_LINKS2.LISTECURITYGUARDS}
                  element={<DoctorSGList />}
                />
                <Route
                  path={APP_LINKS2.DOCTORLISTALLSTAFF}
                  element={<DoctorStaffList />}
                />
                <Route
                  path={APP_LINKS2.DOCTORLISTALLPATIENT}
                  element={<DoctorPatientList />}
                />
                <Route
                  path={APP_LINKS2.DOCTORMYPROFILE}
                  element={<UserProfile />}
                />

                {/*-- Staff Dashboard components -- */}
                <Route
                  path={APP_LINKS.STAFFDASHBOARD}
                  element={<Dashboard />}
                />

                {/*-- Profile components -- */}
                <Route
                  path={APP_LINKS.STAFFMYPROFILE}
                  element={<UserProfile />}
                />

                {/*-- History components -- */}
                <Route path={APP_LINK.HISTORY} element={<HistoryList />} />
                <Route
                  path={APP_LINKS.STAFFHISTORY}
                  element={<HistoryList />}
                />
                <Route
                  path={APP_LINKS2.DOCTORHISTORY}
                  element={<HistoryList />}
                />

                {/*-- Role Permission components -- */}
                <Route
                  path={APP_LINK.ROLEPERMISSION}
                  element={<RolePermissionTable />}
                />
               
                {/*-- Roles components -- */}
                <Route path={APP_LINK.LISTROLELIST} element={<RolesList />} />
                <Route path={APP_LINK.ADDROLELIST} element={<AddRole />} />
                <Route path={APP_LINK.EDITROLELIST} element={<EditRole />} />
                <Route path={APP_LINK.VIEWROLELIST} element={<ViewRole />} />

                {/*-- Logout components -- */}
                <Route path={APP_LINK.LOGOUT} element={<LogoutPage />} />

                {/*-- Patient Transfer components -- */}
                <Route
                  path={APP_LINK.PATIENTTRANSFER}
                  element={<PatientTransferForm />}
                />
                <Route
                  path={APP_LINKS.STAFFPATIENTTRANSFER}
                  element={<PatientTransferForm />}
                />

                <Route path={APP_LINK.BLOCKLIST} element={<BlockList />} />
                <Route path={APP_LINK.FLOORLIST} element={<FloorList />} />
                <Route
                  path={APP_LINK.WARDLIST}
                  element={<HospitalManagementForm />}
                />

                {/*transfer history */}
                <Route
                  path={APP_LINK.TRANSFERHISTORY}
                  element={<OverAllHistoryList />}
                />
                <Route
                  path={APP_LINK.STAFFTRANSFERHISTORY}
                  element={<StaffTransferHistoryList />}
                />
              </Routes>
            </div>
          </main>
        </div>
      </ThemeProvider>
    </Provider>
  );
};

export default RoutesComponent;
